import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
// Constants imports
import { URLConstants } from '../../_constants/url-constants';
// Model imports
import { OwnerLogReturnedMailEditorResultDto } from '../_models/log-returned-mail/owner-log-returned-mail-editor-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class LogReturnedMailService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getLogReturnedMailEditor(communityId, customerId) {
        let url = `${URLConstants.ccOwnerApiBaseUrl}communication/logreturnedmail/editor?clearCache=true&communityId=${communityId}`;
        if (!!customerId) {
            url = `${url}&customerId=${customerId}`;
        }
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(OwnerLogReturnedMailEditorResultDto, response)));
    }
    saveLogReturnedMail(params) {
        const url = `${URLConstants.ccOwnerApiBaseUrl}communication/logreturnedmail`;
        return this.httpClient.post(url, classToPlain(params));
    }
}
LogReturnedMailService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LogReturnedMailService_Factory() { return new LogReturnedMailService(i0.ɵɵinject(i1.HttpClient)); }, token: LogReturnedMailService, providedIn: "root" });
